import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * Specs Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Specs box title
     */
    @Prop() title!: string;

    /**
     * Specs list
     */
    @Prop() specs!: Array<object>;

    /**
     * Table has border
     */
    @Prop() bordered!: boolean;

    /**
     * post hashid
     */
    @Prop({ type: String }) postId!: string;
}
